import React from 'react';

/**
 * TopicQuestionStatsModal Component
 * Replaces the Angular topic-question-stats-modal.html template
 * Shows the number of questions available for each topic at different difficulty levels
 */
const TopicQuestionStatsModal = ({ show, onHide, nodesInLessonPlan }) => {
  if (!show) return null;

  /**
   * Handle modal close
   */
  const handleClose = () => {
    onHide();
  };

  /**
   * Handle backdrop click
   */
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div className="modal fade show" style={{ display: 'block', marginTop: '80px' }} onClick={handleBackdropClick}>
      <div className="modal-dialog modal-lg" style={{ maxWidth: '90%', minWidth: '800px' }}>
        <div className="modal-content">
          
          {/* Modal Header */}
          <div className="modal-header">
            <button 
              type="button" 
              className="close" 
              onClick={handleClose}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">Questions Available for Each Topic</h4>
          </div>

          {/* Modal Body */}
          <div className="modal-body">
            <table className="table">
              
              {/* Table Header */}
              <thead>
                <tr>
                  <td>Topic</td>
                  <td>Beginner</td>
                  <td>Advanced Beginner</td>
                  <td>Competent</td>
                  <td>Expert</td>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody>
                {nodesInLessonPlan && nodesInLessonPlan.length > 0 ? (
                  nodesInLessonPlan.map((node, index) => (
                    <tr key={index}>
                      <td><b>{node.name}</b></td>
                      <td className={node.level1 < 5 ? 'red' : ''}>
                        {node.level1}
                      </td>
                      <td className={node.level2 < 5 ? 'red' : ''}>
                        {node.level2}
                      </td>
                      <td className={node.level3 < 5 ? 'red' : ''}>
                        {node.level3}
                      </td>
                      <td className={node.level4 < 5 ? 'red' : ''}>
                        {node.level4}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No topic data available
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TopicQuestionStatsModal; 